module.exports = __webpack_public_path__ + "static/img/step1_1.a423e77.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/step1_1.png
// module id = RRPp
// module chunks = 1